module.exports = __webpack_public_path__ + "img/LF003-04.e7641d1a.jpg";